export const partOverhangs = [
  "fivePrimeOverhang",
  "fivePrimeUnderhang",
  "threePrimeOverhang",
  "threePrimeUnderhang"
];
